import { Box, makeStyles, Table, TableBody, TableHead } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { energyTypeToEerCoefficientMap } from '../../eer-coefficients/eer-coefficients'
import { PurchasedEnergyType } from '../../generated/graphql'
import { SidebarTableRow } from '../common/SidebarTableRow'

const useStyles = makeStyles((theme) => ({
  table: {
    marginTop: theme.spacing(2),
  },
}))

export function EerSidebarContent(): React.ReactElement {
  const classes = useStyles()
  const { t } = useTranslation()

  const rows = Object.values(PurchasedEnergyType).map((energyType) => ({
    title: t(`purchasedEnergyType.${energyType}`),
    value: energyTypeToEerCoefficientMap[energyType],
  }))

  return (
    <Box display="flex" flexDirection="column" width="100%">
      <Box p={2} display="flex" justifyContent="center">
        <Table size="small" className={classes.table}>
          <TableHead>
            <SidebarTableRow
              title={t('eer.eerCoefficients')}
              values={[null]}
              isHeader
            />
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <SidebarTableRow
                key={row.title}
                title={row.title}
                values={[row.value]}
              />
            ))}
          </TableBody>
        </Table>
      </Box>
    </Box>
  )
}
